import axios from 'axios'
const http = axios

http.defaults.baseURL = process.env.VUE_APP_API

export default http
